import * as Actions from '@/app/store/actions';
import { Close } from '@material-ui/icons';
import { useDispatch } from 'react-redux';

const BlurInfoDialog = ({ fullScreen, setFalse }) => {
	const dispatch = useDispatch();
	const handleClose = () => {
		if (fullScreen) {
			setFalse(false);
		} else {
			dispatch(Actions.closeDialog());
		}
	};
	return (
		<div className="bg-white px-32 min-h-[450px] max-h-[480px] pt-[10px] min-[400px]:min-w-[370px] min-[500px]:min-w-[440px]">
			<div className="flex justify-between py-[10px] px-0 content-center items-center mx-auto font-bold w-[90%]">
				<div>
					<h1 style={{ fontSize: '20px', fontWeight: '700' }}> Blur Information</h1>
				</div>
				<button onClick={handleClose} type="button">
					<Close />
				</button>
			</div>
			<ul className="list-disc mx-32 gap-32">
				<li className="my-16">
					To blur any portion of the live stream, open the live stream in full screen mode and drag the rectangle over
					the area you intend to blur.
				</li>
				<li className="my-16"> Click &apos;Save&apos; to save the blur effect on the live stream.</li>
				<li className="my-16"> To remove the blur effect, click the delete button. </li>
				<li className="my-16">
					To undo the action you just did, simply tap on the left pointing arrow. To redo an action, tap on the right
					pointing arrow.
				</li>
			</ul>
		</div>
	);
};

export default BlurInfoDialog;
